import { getLocationInfos } from '@/helpers/GeoLocation/GeoLocationHelper';
import { localizeLanguage } from '@/helpers/Meta/metaInfoHelper';
import { isPlatformIs24 } from '@/helpers/Platform/Platform';
import { getLocalLandingPagePath } from '@/helpers/Url/Url';
import { router } from '@/router';
import { HgSupportedLanguage } from '@smg-real-estate/domus';
import { GeoLocation, LocalizedData } from '@smg-real-estate/geo-libs';

export function getLocalLandingPageCanonicalLink(path: string) {
  return {
    rel: 'canonical',
    href: `${import.meta.env.VUE_APP_BASE_URL}${path}`,
  };
}

export function getLocalLandingPageAlternateLink(
  locationUrlName: string,
  language: HgSupportedLanguage,
) {
  return {
    rel: 'alternate',
    hreflang: localizeLanguage(language),
    href: `${import.meta.env.VUE_APP_BASE_URL}${getLocalLandingPagePath(language, locationUrlName)}`,
  };
}

export function getLocalLandingPageDefaultAlternateLinks(locationUrlName: string) {
  return {
    rel: 'alternate',
    hreflang: 'x-default',
    href: `${import.meta.env.VUE_APP_BASE_URL}${getLocalLandingPagePath(HgSupportedLanguage.DE, locationUrlName)}`,
  };
}

export function generateMetadataLinks(
  routeGeoLocation: null | GeoLocation,
  locale: HgSupportedLanguage,
  $t: (key: string, plural: number | object) => string,
) {
  const location = getLocationInfos(routeGeoLocation, locale).name;
  const urlNames: LocalizedData<string> | object = isPlatformIs24()
    ? (routeGeoLocation?.is24UrlNames ?? {})
    : (routeGeoLocation?.urlNames ?? {});
  const titleSuffix = isPlatformIs24() ? 'ImmoScout24.ch' : 'Homegate.ch';
  return {
    title: $t(`localLanding.metaInfo.title`, { location }),
    titleTemplate: `%s | ${titleSuffix}`,
    htmlAttrs: {
      lang: locale,
    },
    meta: [
      {
        name: 'description',
        content: $t(`localLanding.metaInfo.description`, { location }),
      },
    ],
    link: [
      getLocalLandingPageCanonicalLink(router.currentRoute.value.path),
      ...Object.keys(urlNames).map((language) =>
        getLocalLandingPageAlternateLink(urlNames[language], language as HgSupportedLanguage),
      ),
      getLocalLandingPageDefaultAlternateLinks(urlNames[HgSupportedLanguage.DE]),
    ],
  };
}
